module.exports = __webpack_public_path__ + "img/con3.f93b41c8.png";